//Ensures there will be no 'console is undefined' errors
window.console = window.console || (function(){
    var c = {}; c.log = c.warn = c.debug = c.info = c.error = c.time = c.dir = c.profile = c.clear = c.exception = c.trace = c.assert = function(s){};
    return c;
})();

function generateUUID () {
	var d = new Date().getTime();

	return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
		var r = (d + Math.random() * 16) % 16 | 0;
		d = Math.floor(d / 16);
		return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
	});
}

function trueOrFalse () {
	return Math.round(Math.random(0));
}

function _log(msg) {
	console.log(msg)
	//window.console.log.apply(this, arguments);
}

/**
 * Search entire object for a property.
 * @param {string} path - "object.property.path"
 * @param {Object} ref - Object to serach
 * @returns {*|undefined}
 */
function _traverseObjectByString(path, ref) {
	var props = path.split('.'),
		prop = props.shift();

	if (!ref.hasOwnProperty(prop))
		return undefined;

	if (!props.length)
		return ref[prop];

	return _traverseObjectByString(props.join('.'), ref[prop]);
}

function isDebug() {
	return !!parseInt(window.sessionStorage.getItem('__te_debug__') || 0, 10);
}

var logList = {}
function logUnique(text) {
	if (logList[text]) {
		logList[text]++
	} else {
		logList[text] = 1
	}
	// console.log(text+':'+logList[text]);
}